import { render } from "./FindAPhysicianComponent.vue?vue&type=template&id=6de75260"
import script from "./FindAPhysicianComponent.vue?vue&type=script&lang=js"
export * from "./FindAPhysicianComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Website\\wwwroot\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__